module.exports = __webpack_public_path__ + "img/electric_use_selected.576ceb2b.svg";